import { BaseDto } from "src/dtos/common/baseDto";
import { CompanyDto } from "src/dtos/company/companyDto";
import { EquipmentDto } from "src/dtos/equipment/equipmentDto";
import { formatDate } from "src/utils/string/stringUtil";

export interface MST4010_R01Dto extends EquipmentDto {

}

export const defaultMST4010_R01Dto: MST4010_R01Dto = {
  	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	
	equipmentCd: '',
	equipmentNm: '',
	equipmentSpec: '',
	eqmSerial: '',
	equipmentType: '',
	workplaceCd: '',
	equipmentSeq: 0,
	displaySeq: 0,
	compCd: '',
	compNm: '',
	eqmOrgcd: '',
	eqmOrgNm: '',
	eqmPerson: '',
	eqmPersonNm: '',
	eqmPower: 0,
	eqmVolt: 0,
	sizeHeight: 0,
	sizeWidth: 0,
	sizeDepth: 0,
	sizeWeight: 0,
	otherSpec: '',
	manufacturerNm: '',
	manufactureDt: formatDate(new Date()),
	purchaseNm: '',
	purchaseDt: formatDate(new Date()),
	purchaseAmt: 0,
	linkIp: '',
	linkPort: '',
	gatheringCycle: 0,
	instrucTag: '',
	virtualEqm: '',
	eqmImage: '',
	eqmImage2: '',
	eqmStatus: '',
	eqmStatusNm: '',
	disposalDt: formatDate(new Date()),
	remark: '',

	inserted: false,
	isModified: false,
	
}
